import styled from '@emotion/styled';

export const QuickActionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  width: 100%;
  height: fit-content;

  a,
  button {
    min-height: 120px;
    align-items: center;
    padding: 12px;
    border-radius: 8px;
    box-shadow: none;

    > div:first-of-type {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;

      > span:last-of-type {
        font-weight: 700;
        color: #262626;
        line-height: 1.25;
      }
    }

    > span:last-of-type {
      align-self: center;
      color: #000fff;
    }
  }

  @media (min-width: 769px) {
    gap: 12px;
    height: 100%;
    min-height: 100%;
    grid-template-rows: repeat(3, 1fr);
    align-content: stretch;

    a,
    button {
      height: 100%;
      min-height: 112px;
      padding: 16px;

      > div:first-of-type {
        flex-direction: row;
        align-items: flex-start;
        gap: 10px;
      }
    }
  }
`;
